import {createSlice} from '@reduxjs/toolkit'
import {HYDRATE} from 'next-redux-wrapper'

interface QuestionsState {
    totalQuestions: number;
    currentQuestion: number;
}

const initialState: QuestionsState = {
    totalQuestions: 0,
    currentQuestion: 0,
}

const QuestionsProgressbarSlice = createSlice({
    name: 'questionsProgressbar',
    initialState,
    reducers: {
        setInitialState: (state, action: { payload: QuestionsState }) => {
            const {totalQuestions, currentQuestion} = action.payload;
            state.totalQuestions = totalQuestions;
            state.currentQuestion = currentQuestion;
        },
        setTotalQuestions: (state, action: { payload: number }) => {
            state.totalQuestions = action.payload
        },
        setCurrentQuestion: (state, action: { payload: number }) => {
            state.currentQuestion = action.payload
        },
    },
    extraReducers: (builder) => {
        builder.addCase(HYDRATE, (state, action) => {
            if ('payload' in action && !action.payload) {
                const hydratedState = action.payload as any
                return {
                    ...state,
                    ...(hydratedState.questionsProgressbar || {}),
                }
            }
        })
    }
})
export const {
    setInitialState,
    setTotalQuestions,
    setCurrentQuestion
} = QuestionsProgressbarSlice.actions
export default QuestionsProgressbarSlice.reducer
